<div class="FullHeightContentContainer">
    <div class="FullHeightContenttHeader">
        <table style="width:100%;">
            <tr>
                <td rowspan="2" style="padding-left:12px;width:1px;">
                    <span class="material-symbols-outlined" style="font-size: 32pt;">
                        notifications_active
                    </span>
                </td>
                <td style="padding-left:38px;">
                    <mat-card-title>Notification Metrics</mat-card-title>
                </td>
            </tr>
            <tr>
                <td style="padding-left:42px;">
                    <mat-card-subtitle>This report gathers notification metrics from both the Remitter Data Lake and SQL Server sources.  Reports run in the background and made available in the report queue beneath the run button</mat-card-subtitle>
                </td>
            </tr>
        </table>
    </div>
    <br />
    <br />
    <div class="FullHeightContentContent">
        <div class="p-field" style="width: 480px; padding-left: 12px;">
            <p-floatLabel>
                <p-autoComplete [(ngModel)]="selectedCreditor"
                                [suggestions]="filteredItems"
                                (completeMethod)="filterItems($event)"
                                (onSelect)="onCreditorSelected($event)"
                                field="LongNameWithId"
                                [dropdown]="true"
                                placeholder="Select Creditor"
                                id="creditors"
                                [style]="{ width: '100%' }">
                    <ng-template let-creditor pTemplate="item">
                        <div class="flex align-items-center justify-content-between flex-1">
                            <div>{{creditor.CompanyName}}</div>
                            <div>{{creditor.CreditorId.replace('creditor/','')}}</div>
                        </div>
                    </ng-template>
                </p-autoComplete>
            </p-floatLabel>
        </div>
        <br />
        <div class="p-field" style="width: 480px; padding-left: 12px;">
            <p-multiSelect [options]="statusesList"
                           [(ngModel)]="searchParameters.NotificationStatusIds"
                           optionLabel="Name"
                           optionValue="Id"
                           defaultLabel="Select Statuses"
                           [showToggleAll]="true"
                           [filter]="false"
                           id="notificationStatuses"
                           [style]="{width: '100%'}">
            </p-multiSelect>
        </div>
        <br />
        <div class="p-field" style="width: 480px; padding-left: 12px; padding-top: 4px;">
            <p-multiSelect [options]="typesList"
                           [(ngModel)]="searchParameters.NotificationTypeIds"
                           optionLabel="Name"
                           optionValue="Id"
                           defaultLabel="Select Types"
                           [showToggleAll]="true"
                           [filter]="false"
                           id="notificationTypes"
                           [style]="{width: '100%'}">
            </p-multiSelect>
        </div>
        <br />
        <div style="display: flex; gap: 12px; padding-left: 12px; padding-top: 4px;">
            <div class="p-float-label" style="width: 230px;">
                <p-calendar [(ngModel)]="searchParameters.FromDate"
                            inputId="fromDate"
                            dateFormat="mm/dd/yy"
                            showIcon="true"
                            [showButtonBar]="true">
                </p-calendar>
                <label for="fromDate">From Date</label>
            </div>
            <div class="p-float-label" style="width: 230px;">
                <p-calendar [(ngModel)]="searchParameters.ToDate"
                            inputId="toDate"
                            dateFormat="mm/dd/yy"
                            showIcon="true"
                            [showButtonBar]="true">
                </p-calendar>
                <label for="toDate">To Date</label>
            </div>
        </div>
        <br />
        <div style="display: flex; gap: 12px; padding-left: 12px; padding-top: 4px;">
            <div class="p-float-label" style="width: 226px;">
                <input pInputText id="integrationLinkId" maxlength="256" [(ngModel)]="searchParameters.IntegrationLinkId" name="IntegrationLinkId" style="width: 229px;" />
                <label for="integrationLinkId">Integration Link ID</label>
            </div>
            <button pButton
                    type="button"
                    class="text-xs ml-1" 
                    (click)="runReport()"
                    pTooltip="Run the report"
                    tooltipPosition="top"
                    style="width: 232px;" 
                    [disabled]="((this.searchParameters.CreditorId.trim() == '' || this.searchParameters.NotificationStatusIds.length == 0 || this.searchParameters.NotificationTypeIds.length == 0 || this.searchParameters.FromDate == null || this.searchParameters.ToDate == null) || (this.searchParameters.ToDate < this.searchParameters.FromDate))">
                <span class="pi pi-search text-xs mr-2"></span>
                <span style="width: 100%; cursor: pointer;">RUN REPORT</span>
                <span style="visibility: hidden;"
                      class="pi pi-exclamation-triangle text-yellow-500 ml-2"
                      pTooltip="Your parameters are no good"
                      tooltipPosition="top">
                </span>
            </button>
            <span *ngIf="((this.searchParameters.CreditorId.trim() == '' || this.searchParameters.NotificationStatusIds.length == 0 || this.searchParameters.NotificationTypeIds.length == 0 || this.searchParameters.FromDate == null || this.searchParameters.ToDate == null) || (this.searchParameters.ToDate < this.searchParameters.FromDate))"
                  style="position: relative; left: -52px; top: 14px; color: red !important;"
                  class="pi pi-exclamation-triangle text-yellow-500 ml-2"
                  pTooltip="Unable to run report.  Correct your parameters by providing a creditor, at least one status, one type and a date range where the to date is equal to or greater than the from date."
                  tooltipPosition="top">
            </span>
        </div>
    </div>
    <br />
    <div class="mt-4 pt-2 px-3">
        <p-table [value]="reportsListDataSource" [paginator]="true" [rows]="25" [tableStyle]="{ 'min-width': '50rem' }" [rowsPerPageOptions]="[25, 100]">
            <ng-template pTemplate="header">
                <tr class="text-xs">
                    <th></th> <!-- actions such as download, cancel etc -->
                    <th></th> <!-- ready, progress etc -->
                    <th>Begin Processing (UTC)</th>
                    <th>Finish Processing (UTC)</th>
                    <th>Duration</th>
                    <th>Creditor</th>
                    <th>Dates</th>
                    <th>Types</th>
                    <th>Statuses</th>
                    <th>Integration Link</th>
                    <th>Successfully Processed</th>
                    <th>Message</th>
                    <th>Created on (UTC)</th>
                    <th>Created By</th>
                    <th>Available Until (UTC)</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-report>
                <tr class="text-xs">
                    <td>
                        <div class="flex align-items-center">
                            <i *ngIf="report.FinishedOnUtc == null && !pendingCancellationNotificationMetricsRunIds.includes(report.NotificationMetricsRunId)" class="pi pi-times text-xs text-red-500 cursor-pointer" style="color: red !important;" pTooltip="Cancel Report" tooltipPosition="left" (click)="cancelReport(report.NotificationMetricsRunId)"></i>
                            <i *ngIf="pendingCancellationNotificationMetricsRunIds.includes(report.NotificationMetricsRunId)" class="pi pi-hourglass text-xs text-red-500 cursor-pointer" style="color: purple !important;" pTooltip="Pending cancellation..." tooltipPosition="left"></i>
                        </div>
                        <div class="flex align-items-center">
                            <i  *ngIf="report.FinishedOnUtc != null"
                                class="pi pi-download text-xs"
                                [class.cursor-pointer]="report.RowsCapturedCount > 0"
                                [ngClass]="report.RowsCapturedCount > 0 ? 'download-enabled' : 'download-disabled'"
                                [pTooltip]="report.RowsCapturedCount > 0 ? 'Download report file' : 'Nothing to download'"
                                tooltipPosition="left"
                                (click)="report.RowsCapturedCount > 0 && downloadReport(report.NotificationMetricsRunId)">
                            </i>
                        </div>
                    </td>
                    <td>
                        <i *ngIf="report.RowsCapturedCount <= 1048575 && report.FinishedOnUtc != null && report.CancelRequestedOnUtc == null" class="pi pi-check ml-2" style="visibility: hidden;" style="color: green !important;" pTooltip="Processing completed" tooltipPosition="left"></i>
                        <i *ngIf="report.RowsCapturedCount <= 1048575 && report.FinishedOnUtc != null && report.CancelRequestedOnUtc != null" class="pi pi-check ml-2" style="visibility: hidden;" style="color: purple !important;" pTooltip="Processing completed prematurely due to a cancellation request" tooltipPosition="left"></i>
                        <i *ngIf="report.RowsCapturedCount > 1048575 && report.FinishedOnUtc != null" class="pi pi-exclamation-triangle text-yellow-500 ml-2" style="color: darkorange !important" pTooltip="This report is too large to be opened in Excel.  Run the report again in multiple smaller portions if you need to open this in Excel" tooltipPosition="left"></i>
                        <p-progressSpinner *ngIf="report.FinishedOnUtc == null" styleClass="tiny-spinner" strokeWidth="4" fill="#ffffff" animationDuration=".8s"></p-progressSpinner>
                    </td>
                    <td>{{ report.StartedOnUtc | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    <td>{{ report.FinishedOnUtc | date:'yyyy-MM-dd HH:mm:ss' }}</td>
                    <td>{{ report.StartedOnUtc | duration:report.FinishedOnUtc }}</td>
                    <td>{{ report.ParameterCreditorName }}</td>
                    <td>{{ report.ParameterDateSelection }}</td>
                    <td>{{ report.ParameterNotificationTypes }}</td>
                    <td>{{ report.ParameterNotificationStatuses }}</td>
                    <td>{{ report.ParameterIntegrationLinkId }}</td>
                    <td>{{ report.IsSuccess }}</td>
                    <td>
                        <div *ngIf="report.FinishedOnUtc == null">
                            Currently processing day {{ report.DaysProcessedCount | number }} of total requested days {{ report.DaysRequestedCount | number }}. Cumulative rows captured so far is {{ report.RowsCapturedCount | number }}.
                        </div>
                        <div *ngIf="report.FinishedOnUtc != null">
                            {{ report.CompletionMessage }}
                        </div>
                    </td>
                    <td>{{ report.CreatedOnUtc }}</td>
                    <td>{{ report.CreatedBy }}</td>
                    <td>{{ report.AvailableUntilUtc }}</td>
                </tr>
            </ng-template>
        </p-table>
        <div class="FullHeightContentFooter">
        </div>
    </div>
</div>
